import { atom } from "recoil"
import { QuizItemType } from "../../../types"

const quizItemsState = atom<QuizItemType[]>({
  key: "quizItemsState",
  default: new Array<QuizItemType>(20),
})

export default quizItemsState
